export function csvEscape(val) {
  const s = val == null ? '' : String(val);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function safeCsvSlug(text, maxLen = 48) {
  return (text || 'campaign').replace(/[^\w.-]+/g, '_').slice(0, maxLen);
}

export function filterLabelFromList(filters, filterId, fallback = 'All') {
  return filters?.find((f) => f.id === filterId)?.label || fallback;
}

/** Trigger UTF-8 CSV download in the browser. */
export function triggerCsvDownload(filename, csvBody) {
  const body = `\uFEFF${csvBody}`;
  const blob = new Blob([body], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
